import React, { Component, createRef } from "react";
import { isEqual } from "lodash";
import { SearchBar } from "component/menu";
import { ReactComponent as ArrowDown } from "assets/icons/arrow-down-2.svg";
import { ReactComponent as ArrowUp } from "assets/icons/arrow-up.svg";
import { ReactComponent as ScratchCardsIcon } from "assets/icons/scratch cards.svg";
import { ReactComponent as SlotIconActive } from "assets/icons/Slots-active.svg";
import { ReactComponent as SlotIconInactive } from "assets/icons/Slots-inactive.svg";
import { ReactComponent as TableGamesIconActive } from "assets/icons/TableGames-active.svg";
import { ReactComponent as TableGamesIconInactive } from "assets/icons/TableGames-inactive.svg";
import { ReactComponent as VirtualSportsIconActive } from "assets/icons/VirtualSports-active.svg";
import { ReactComponent as VirtualSportsIconInactive } from "assets/icons/VirtualSports-inactive.svg";
import { ReactComponent as CrashGamesIconActive } from "assets/icons/CrashGames-active.svg";
import { ReactComponent as CrashGamesIconInactive } from "assets/icons/CrashGames-inactive.svg";
import { ReactComponent as LiveCasinoIconActive } from "assets/icons/LiveCasino-active.svg";
import { ReactComponent as LiveCasinoIconInactive } from "assets/icons/LiveCasino-inactive.svg";
import { ReactComponent as InstantWinIconActive } from "assets/icons/InstantWin-active.svg";
import { ReactComponent as InstantWinIconInactive } from "assets/icons/InstantWin-inactive.svg";
import { ReactComponent as LotteryIconActive } from "assets/icons/Lottery-active.svg";
import { ReactComponent as LotteryIconInactive } from "assets/icons/Lottery-inactive.svg";
import { ReactComponent as ShootingIconActive } from "assets/icons/Shooting-active.svg";
import { ReactComponent as ShootingIconInactive } from "assets/icons/Shooting-inactive.svg";
import { ReactComponent as GameShowsIconActive } from "assets/icons/GameShows-active.svg";
import { ReactComponent as GameShowsIconInactive } from "assets/icons/GameShows-inactive.svg";
import { ReactComponent as EsportsIconActive } from "assets/icons/ESports-active.svg";
import { ReactComponent as EsportsIconInactive } from "assets/icons/Esports-inactive.svg";
import { ReactComponent as SportsIconActive } from "assets/icons/Sports-active.svg";
import { ReactComponent as SportsIconInactive } from "assets/icons/Sports-inactive.svg";
import { ReactComponent as GearsIcon } from "assets/icons/gears.svg";
import { ReactComponent as TypesIcon } from "assets/icons/Types.svg";
import { ReactComponent as VarianceIcon } from "assets/icons/Variance.svg";
import { ReactComponent as PuzzlePieceIcon } from "assets/icons/puzzle_piece.svg";
import { ReactComponent as PantoneIcon } from "assets/icons/pantone.svg";
import { withNamespaces } from "react-i18next";

import { CategoryGameTypeFilterComponent } from "component/filters";
import "component/filters/ShowMoreFilter/styles.scss";

class ShowMoreFilter extends Component {
  constructor(props) {
    super(props);
    this.accordionRef = createRef();
    this.combinedRef = createRef();
    this.expandHandler = this._expandHandler.bind(this);
    this.getPlaceHolderText = this._getPlaceHolderText.bind(this);
    this.highlightText = this._highlightText.bind(this);
    this.state = {
      showMore: false,
      filterValues: props.filter ? props.filter.get("values") : null,
      expand: true,
      sortFilterValues: props.filter
        ? props.filter.get("values").sort((a, b) => a.get("name").localeCompare(b.get("name")))
        : null,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (!isEqual(prevProps.filter, this.props.filter) && this.props.filter) {
      let sortFilterValues;
      let search = this.props.filter.get("search");
      let filterValues = this.props.filter.get("values");
      let enabledCount = this.props.filter.get("enabledCount");
      filterValues = filterValues.filter((value) => {
        if (search)
          return (
            value
              .get("name")
              .toLowerCase()
              .indexOf(search.toLowerCase()) > -1 && value.get("enabled")
          );
        return value.get("enabled");
      });
      enabledCount = filterValues.filter((value) => value.get("enabled")).size;

      try {
        sortFilterValues = filterValues.sort((a, b) =>
          a.get("name").localeCompare(b.get("name"))
        );
      } catch (err) {}

      this.setState({
        filterValues,
        sortFilterValues,
        enabledCount,
      });
    }

    if (this.props.activeFilter !== prevProps.activeFilter) {
      if (!prevProps.isVisible) {
        this.setState({ expand: true });
      }
      if (prevProps.filter && this.props.activeFilter === prevProps.filter.get("id")) {
        this.setState({ expand: true });
        if (this.accordionRef.current) {
          this.accordionRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
        }
      }

      const isCombinedActive = this.props.activeFilter === "category" || this.props.activeFilter === "gameType";
      const isCombinedShowing = this.props.categoryFilter || this.props.gameTypeFilter;

      if (isCombinedActive && isCombinedShowing) {
        setTimeout(() => {
          if (this.combinedRef.current) {
            this.combinedRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            inline: "nearest",

            });
          }
        }, 100);
      }
    }
  }

  _expandHandler() {
    this.setState({ expand: !this.state.expand });
    if (this.accordionRef.current) {
      this.accordionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  }

  _getPlaceHolderText(id) {
    const { t } = this.props;
    switch (id) {
      case "themes":
        return t("findTheme");
      case "specialFeature":
        return t("findFeature");
      case "category":
      case "gameType":
        return t("findType");
      case "providers":
        return t("findProviders");
      default:
        return id;
    }
  }

  _highlightText(text, search) {
    if (!search || !text) return text;
    const regex = new RegExp(`(${search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    const parts = text.split(regex);
    return parts.map((part, index) =>
      regex.test(part) ? (
        <span key={index} className="search-highlight">
          {part}
        </span>
      ) : (
        part
      )
    );
  }

  renderSearchBar() {
    let hide;

    if (this.props.filter && this.props.filter.get("search")) {
      hide = false;
    } else if (this.state.filterValues && this.state.filterValues.size <= 10) {
      hide = true;
    }

    return (
      <SearchBar
        placeholder={this.getPlaceHolderText(this.props.filter.get("id"))}
        search={this.props.filter ? this.props.filter.get("search") : undefined}
        hide={hide}
        onInput={(value) => {
          this.props.filterSearch(value);
        }}
      />
    );
  }

  renderFilterIcons(filter) {
    switch (filter) {
      case "providers":
        return <GearsIcon />;
      case "gameType":
        return <TypesIcon />;
      case "specialFeature":
        return <PuzzlePieceIcon />;
      case "themes":
        return <PantoneIcon />;
      case "volatility":
        return <VarianceIcon />;
      case "category":
        return <TypesIcon />;
      default:
        return <GearsIcon />;
    }
  }

  renderCategory() {
    const { t } = this.props;
    const search = this.props.filter ? this.props.filter.get("search") : "";

    return (
      <div className="accordion-body">
        {this.renderSearchBar()}
        <div className="row nopadding">
          {this.state.filterValues &&
            this.state.filterValues.map((value, key) => {
              if (!value.getIn(["enabled"])) return null;

              let isActive = value.get("toggled");
              let Icon;

              switch (value.get("id")) {
                case "INSTANTWIN":
                  Icon = isActive
                    ? InstantWinIconActive
                    : InstantWinIconInactive;
                  break;
                case "SLOT":
                  Icon = isActive ? SlotIconActive : SlotIconInactive;
                  break;
                case "VIRTUAL_SPORTS":
                  Icon = isActive
                    ? VirtualSportsIconActive
                    : VirtualSportsIconInactive;
                  break;
                case "TABLEGAME":
                  Icon = isActive
                    ? TableGamesIconActive
                    : TableGamesIconInactive;
                  break;
                case "SCRATCHCARD":
                  Icon = ScratchCardsIcon;
                  break;
                case "ESPORTS":
                  Icon = isActive ? EsportsIconActive : EsportsIconInactive;
                  break;
                case "LIVECASINO":
                  Icon = isActive
                    ? LiveCasinoIconActive
                    : LiveCasinoIconInactive;
                  break;
                case "LOTTERY":
                  Icon = isActive ? LotteryIconActive : LotteryIconInactive;
                  break;
                case "SHOOTING":
                  Icon = isActive ? ShootingIconActive : ShootingIconInactive;
                  break;
                case "CRASH":
                  Icon = isActive
                    ? CrashGamesIconActive
                    : CrashGamesIconInactive;
                  break;
                case "GAME_SHOW":
                  Icon = isActive ? GameShowsIconActive : GameShowsIconInactive;
                  break;
                case "SPORTS":
                  Icon = isActive ? SportsIconActive : SportsIconInactive;
                  break;
                default:
                  Icon = isActive ? SlotIconActive : SlotIconInactive;
                  break;
              }

              return (
                <div
                  className={`col-4 category-icon text-center ${
                    value.get("toggled") ? "toggled" : ""
                  }`}
                  key={key}
                  onClick={(event) => {
                    event.stopPropagation();
                    this.props.onFilterClickHandler(
                      this.props.filter.get("id"),
                      value,
                    );
                  }}
                >
                  <div className="d-flex justify-content-center align-items-center">
                    <div className="icon">
                      <Icon />
                      <div className="w-100 category-name">
                        {this.highlightText(value.get("name"), search)}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        {this.props.filter && this.state.sortFilterValues.size === 0 && (
          <>
            <div className="row d-none" />
            <div className="row disabled">
              <div className="col text-center">{t("noResultFound")}</div>
            </div>
          </>
        )}
      </div>
    );
  }

  renderDefault() {
    const { t } = this.props;
    const search = this.props.filter ? this.props.filter.get("search") : "";

    return (
      <div className={`accordion-body ${this.state.showMore ? "expand" : ""}`}>
        {this.renderSearchBar()}
        {this.state.showMore === false &&
          this.state.filterValues &&
          this.state.filterValues.map((value, key) => {
            if (!value.getIn(["enabled"])) return null;

            let imageUrl = value.getIn(["leadingIcon", "imgUrl"]);

            if (imageUrl) {
              imageUrl = `${imageUrl}&theme=dark`;
            }

            return (
              <div
                className={`row align-items-center ${
                  value.get("toggled") ? "selected" : ""
                }`}
                key={key}
                onClick={(event) => {
                  event.stopPropagation();
                  this.props.onFilterClickHandler(
                    this.props.filter.get("id"),
                    value,
                  );
                }}
              >
                <div className="col d-flex align-items-center">
                  {imageUrl && (
                    <img
                      className="item-icon"
                      src={imageUrl}
                      alt={value.get("name")}
                    />
                  )}

                  <span>{this.highlightText(value.get("name"), search)}</span>
                </div>
                <div className="col-auto form-check-label">
                  <span>{value.get("count")}</span>
                </div>
                <div className="col-auto">
                  <input
                    className="form-check-input"
                    type={
                      this.props.filter.get("isMultiSelectable")
                        ? "checkbox"
                        : "radio"
                    }
                    aria-label="..."
                    checked={
                      value.get("toggled") ? value.get("toggled") : false
                    }
                    readOnly
                  />
                </div>
              </div>
            );
          })}
        {this.state.showMore === true &&
          this.state.sortFilterValues &&
          this.state.sortFilterValues.map((value, key) => {
            if (!value.getIn(["enabled"])) return null;

            let imageUrl = value.getIn(["leadingIcon", "imgUrl"]);

            if (imageUrl) {
              imageUrl = `${imageUrl}&theme=dark`;
            }

            return (
              <div
                className={`row align-items-center ${
                  value.get("toggled") ? "selected" : ""
                }`}
                key={key}
                onClick={(event) => {
                  event.stopPropagation();
                  this.props.onFilterClickHandler(
                    this.props.filter.get("id"),
                    value,
                  );
                }}
              >
                <div className="col d-flex align-items-center">
                  {imageUrl && (
                    <img
                      className="item-icon"
                      src={imageUrl}
                      alt={value.get("name")}
                    />
                  )}
                  <span>{this.highlightText(value.get("name"), search)}</span>
                </div>
                <div className="col-auto form-check-label">
                  <span>{value.get("count")}</span>
                </div>
                <div className="col-auto">
                  <input
                    className="form-check-input"
                    type={
                      this.props.filter.get("isMultiSelectable")
                        ? "checkbox"
                        : "radio"
                    }
                    aria-label="..."
                    checked={
                      value.get("toggled") ? value.get("toggled") : false
                    }
                    readOnly
                  />
                </div>
              </div>
            );
          })}
        {this.props.filter && this.state.sortFilterValues.size === 0 && (
          <>
            <div className="row d-none" />
            <div className="row-no-result disabled">
              <div className="col text-center">{t("noResultFound")}</div>
            </div>
          </>
        )}
      </div>
    );
  }

  renderVolatility() {
    const { t } = this.props;
    const search = this.props.filter ? this.props.filter.get("search") : "";

    return (
      <div
        className={`accordion-body volatility ${
          this.state.showMore ? "expand" : ""
        }`}
      >
        {this.renderSearchBar()}
        <div className="row nopadding">
          {this.state.showMore === false &&
            this.state.filterValues &&
            this.state.filterValues.map((value, key) => {
              if (!value.getIn(["enabled"])) return null;

              return (
                <div
                  className={`col-4 volatility  ${
                    value.get("toggled") ? "toggled" : ""
                  }`}
                  key={key}
                >
                  <div
                    className="d-flex justify-content-center align-items-center"
                    onClick={(event) => {
                      event.stopPropagation();
                      this.props.onFilterClickHandler(
                        this.props.filter.get("id"),
                        value,
                      );
                    }}
                  >
                    <div className="text-center">
                      {this.highlightText(value.get("name"), search)}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        {this.props.filter && this.state.sortFilterValues.size === 0 && (
          <>
            <div className="row d-none" />
            <div className="row disabled">
              <div className="col text-center">{t("noResultFound")}</div>
            </div>
          </>
        )}
      </div>
    );
  }

  render() {
    if (this.props.categoryFilter || this.props.gameTypeFilter) {
      return (
        <div 
          ref={this.combinedRef}
          style={{ scrollMarginTop: "80px" }}
        > 
          <CategoryGameTypeFilterComponent
            categoryFilter={this.props.categoryFilter}
            gameTypeFilter={this.props.gameTypeFilter}
            onFilterClickHandler={this.props.onFilterClickHandler}
            category={this.props.category}
            t={this.props.t}
          />
        </div>
      );
    }

    const { t } = this.props;
    let subHidden = document.querySelector(`.sub-hidden`);

    return (
      <div
        className={`accordion-item ${
          this.props.filter.get("visible") !== false ||
          this.props.filter.get("toggledCount") > 0
            ? ""
            : "d-none"
        }`}
        ref={this.accordionRef}
      >
        <div
          className="accordion-header"
          onClick={(event) => {
            event.stopPropagation();
            this.expandHandler();
          }}
        >
          <div
            className={`accordion-button w-100 ${
              this.props.filter.get("visible") !== false ||
              this.props.filter.get("toggledCount") === 1
                ? this.props.filter.get("id").toLowerCase()
                : ""
            }`}
          >
            <div className="row">
              <div className="col">
                <div>
                  <span className="filter-icon">
                    {this.renderFilterIcons(this.props.filter.get("id"))}{" "}
                  </span>
                  {`${
                    this.props.filter.get("id") === "category"
                      ? t("types")
                      : this.props.filter.get("name")
                  } ${
                    this.props.filter.get("toggledCount") &&
                    this.props.filter.get("toggledCount") > 0
                      ? ` (${
                          subHidden &&
                          this.props.filter.get("id") === "category" &&
                          subHidden.textContent !== ""
                            ? this.props.filter.get("toggledCount") + 1
                            : this.props.filter.get("toggledCount")
                        })`
                      : ""
                  }`}
                </div>
                <div className={`sub sub-${this.props.filter.get("id")}`}>
                  {(this.props.activeFilter !== null ||
                    (this.props.activeFilter === "category" &&
                      this.props.filter.get("id") === "gameType")) &&
                    this.props.filter
                      .get("values")
                      .filter((value) => value.get("toggled") === true)
                      .map((value) => value.get("name"))
                      .join(", ")}
                  {subHidden &&
                  this.props.filter.get("id") === "category" &&
                  subHidden.textContent !== ""
                    ? `, ${subHidden.textContent}`
                    : ""}
                </div>
              </div>
              <div className="col-auto">
                {!this.state.expand && <ArrowDown />}
                {this.state.expand && <ArrowUp />}
              </div>
            </div>
          </div>
        </div>
        <div
          className={`accordion-collapse collapse ${
            this.state.expand ? "show" : ""
          }
          ${
            this.state.expand && this.props.filter.get("id") === "category"
              ? "types-filters"
              : `${this.props.filter.get("id")}M`
          }`}
        >
          {this.props.filter.get("id") === "category" && this.renderCategory()}
          {this.props.filter.get("id") !== "category" &&
            this.props.filter.get("id") !== "volatility" &&
            this.renderDefault()}
          {this.props.filter.get("id") === "volatility" && this.renderVolatility()}
          {this.props.filter.get("id") === "gameType" && (
            <span className="sub-hidden">
              {this.props.filter
                .get("values")
                .filter((value) => value.get("toggled") === true)
                .map((value) => value.get("name"))
                .join(", ")}
            </span>
          )}
          {this.props.filter.get("id") !== "category" && (
            <div
              className="expand-link"
              onClick={() => this.setState({ showMore: !this.state.showMore })}
            >
              {this.state.enabledCount === undefined
                ? this.state.filterValues.size > 10 && (
                    <span className="btn btn-link">
                      {!this.state.showMore && (
                        <span>{`+${this.state.filterValues.size - 10} ${t("more")}`}</span>
                      )}
                      {this.state.showMore && <span>{t("less")}</span>}
                    </span>
                  )
                : this.state.enabledCount > 10 && (
                    <span className="btn btn-link">
                      {!this.state.showMore && (
                        <span>{`+${
                          this.state.filterValues.size > this.state.enabledCount
                            ? this.state.enabledCount - 10
                            : this.state.filterValues.size - 10
                        } ${t("more")}`}</span>
                      )}
                      {this.state.showMore && <span>{t("less")}</span>}
                    </span>
                  )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withNamespaces("translation")(ShowMoreFilter);
